import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header, Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import ProfileItem from '../ProfileItem';
export default function PersonalInfo() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  if (!customer) return /*#__PURE__*/React.createElement(Title, null, t('profile.no_profile'));
  return /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Header, null, t('profile.contact_info')), /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.first_name'),
    value: customer.personFirstName
  }), /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.last_name'),
    value: customer.personLastName
  }), /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.birth_date'),
    value: dateTimeFormatter(customer.dateOfBirth)
  }));
}